import React from "react";
import styles from "./styles.module.scss";
import ResourceCard from "../ResourceCard";
import NoResources from "../NoResources";
import { MediaModel } from "app/models";
import { Loading } from "app/components/Wrappers";

interface Props {
  data: MediaModel[];
  pending?: boolean;
  containerRef?: any;
  onSelectMedia?: (media: MediaModel) => void;
  thumbnailClassname?: string;
  showPlayIcon?: boolean;
  showTags?: boolean;
  selectedList?: MediaModel[];
}

const ResourcesList = ({
  data,
  pending,
  containerRef,
  onSelectMedia,
  selectedList,
  thumbnailClassname,
  showPlayIcon,
  showTags,
}: Props) => {
  if (pending && data?.length === 0) {
    return (
      <div className={styles.loading_container}>
        <div className={styles.loading_spinner}>
          <Loading loadType="spinner" isLoading={pending} />
        </div>
      </div>
    );
  }

  if (data?.length === 0 && !pending) {
    return <NoResources />;
  }

  return (
    <div className={styles.container}>
      {data?.length > 0 && (
        <div className={styles.items_container}>
          {data?.map((item: MediaModel) => (
            <div
              key={item?.id}
              className={styles.media_container}
              onClick={() => onSelectMedia(item)}
            >
              <ResourceCard
                key={item?.id}
                data={item}
                thumbnailClassname={thumbnailClassname}
                showPlayIcon={showPlayIcon}
                showTags={showTags}
                onSelectMedia={onSelectMedia}
                isSelected={selectedList?.some(
                  (selected) => selected.id === item.id,
                )}
              />
            </div>
          ))}
        </div>
      )}
      {containerRef && <div ref={containerRef} />}
      {pending && (
        <Loading
          isLoading={pending}
          loadType="spinner"
          className={styles.loader}
        />
      )}
    </div>
  );
};

export default ResourcesList;
